export const QUESTION_TYPE = {
  TASK: 'task',
  FOLLOW_UP_QUESTION: 'followUpQuestion',
  TREE_TEST: 'tree_test',
};
